/* PDP 库存三态（IN STOCK / LOW STOCK / OUT OF STOCK）+ 补货报名：独立于主题 Product/Cart 实现。 */
(function () {
  'use strict';
  /* 2026-10-06：只执行一次。快速预览资源改为全站加载（购物车抽屉推荐「+」开快速预览），
     PDP / 分类页自己也会挂同一个文件 → 同一页出现两个 <script src>，第二份直接让位，
     否则事件委托会绑两遍（点一次触发两次）。 */
  if (window.__amadaRestockLoaded) return;
  window.__amadaRestockLoaded = true;

  var ROOT_SELECTOR = '[data-amada-restock]';
  var QUICK_VIEW_DRAWER_SELECTOR = "[data-amada-drawer='amada-quickview']";
  var OPEN_CLASS = 'is-open';
  var LOCK_CLASS = 'amada-restock-modal-open';
  var TRANSITION_MS = 200;
  var DEFAULT_LOW_THRESHOLD = 10;
  var SUBMIT_TIMEOUT_MS = 10000;
  var SUCCESS_MESSAGE = 'Thanks. Your request has been received.';
  var ERROR_MESSAGE = "We couldn't submit your request. Please try again.";
  var CHALLENGE_MESSAGE = 'Shopify could not verify this request. Please refresh the page and try again.';
  var SUCCESS_BODY = 'We will email you as soon as this item is back in stock.';
  /* 原生提交（captcha 接管时唯一走得通的路径）会整页跳走，回跳后靠这条 sessionStorage
     记录来判断“刚刚确实提交过补货报名”。键名必须与 layout/theme.liquid 里的内联脚本一致。 */
  var PENDING_KEY = 'amada:restock:pending';

  function parseVariants(root) {
    var node = root.querySelector('[data-amada-restock-variants]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]');
    } catch (error) {
      console.error('[amada-back-in-stock] Invalid variant JSON', error);
      return [];
    }
  }

  /**
   * 库存数量表：{ 变体id: { tracked: Boolean, quantity: Number } }
   * 主源是本组件自己发的 [data-amada-restock-inventory]；
   * 兜底读主题原生库存组件的 [data-product-inventory-json]（它同样由 Liquid 渲染，
   * 字段名不同：inventory_management / inventory_quantity）。
   * 两份都取不到时返回空表 —— 判据里会因此降级成「有货」，宁可少报不误报。
   */
  function parseInventory(root) {
    var map = {};
    var own = root.querySelector('[data-amada-restock-inventory]');
    if (own) {
      try {
        var raw = JSON.parse(own.textContent || '{}');
        for (var id in raw) {
          if (!Object.prototype.hasOwnProperty.call(raw, id)) continue;
          map[String(id)] = {
            tracked: Boolean(raw[id] && raw[id].tracked),
            quantity: raw[id] && typeof raw[id].quantity === 'number' ? raw[id].quantity : null
          };
        }
      } catch (error) {
        console.error('[amada-back-in-stock] Invalid inventory JSON', error);
      }
    }

    var themeNode = document.querySelector('[data-product-inventory-json]');
    if (themeNode) {
      try {
        var themeRaw = (JSON.parse(themeNode.textContent || '{}') || {}).inventory || {};
        for (var themeId in themeRaw) {
          if (!Object.prototype.hasOwnProperty.call(themeRaw, themeId)) continue;
          if (map[String(themeId)]) continue; /* 自家数据优先 */
          var entry = themeRaw[themeId] || {};
          map[String(themeId)] = {
            tracked: Boolean(entry.inventory_management),
            quantity: typeof entry.inventory_quantity === 'number' ? entry.inventory_quantity : null
          };
        }
      } catch (error) {
        console.error('[amada-back-in-stock] Invalid theme inventory JSON', error);
      }
    }
    return map;
  }

  /** 变体自带字段优先（主题派发的变体对象带 inventory_management，个别场景还带数量），取不到再查表。 */
  function readInventory(variant, inventory) {
    var entry = (inventory || {})[String(variant.id)] || null;
    var management = variant.inventory_management;
    var tracked = management === undefined
      ? Boolean(entry && entry.tracked)
      : Boolean(management);
    var quantity = typeof variant.inventory_quantity === 'number'
      ? variant.inventory_quantity
      : (entry && typeof entry.quantity === 'number' ? entry.quantity : null);
    return { tracked: tracked, quantity: quantity };
  }

  /**
   * 三态判据（2026-08-31 用户拍板，与 snippets/amada-back-in-stock.liquid 的服务端初值必须一致）：
   *   A 有货   = available 且不属于 C                       → IN STOCK
   *   C 低库存 = available 且**有跟踪库存**且 数量 < 阈值    → LOW STOCK（只显示这句，不显示数量）
   *   B 缺货   = available === false                        → OUT OF STOCK + Notify 按钮
   * 「预售 / 允许超卖（inventory_policy === 'continue'）」按用户决定不单独成一态，
   * 这里刻意**不写任何 continue 分支**：只要 available 就落 A 或 C。
   *
   * 🚨 陷阱（tracked 判断不能省）：variant.inventory_quantity 只有在 inventory_management
   *    非空（有跟踪库存）时才可靠。**未跟踪库存的商品 quantity 恒为 0，但 available 是 true** ——
   *    如果只判 `quantity < 10`，这类商品会被**全部误报成 LOW STOCK**。
   *    同理，库存数据整个取不到（quantity === null）时也必须降级成 IN STOCK。
   */
  function stockState(variant, inventory, threshold) {
    if (!variant) return '';
    if (variant.available === false) return 'out';
    var info = readInventory(variant, inventory);
    if (info.tracked && typeof info.quantity === 'number' && info.quantity < threshold) return 'low';
    return 'in';
  }

  function findVariant(variants, id) {
    var wanted = String(id || '');
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === wanted) return variants[i];
    }
    return null;
  }

  function setButtonState(button, variant) {
    var text = button.querySelector('[data-add-to-cart-text]');
    var isSticky = Boolean(button.closest('.sticky-atc-bar'));

    if (variant && variant.available) {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      button.setAttribute('aria-label', button.dataset.langAvailable || 'Add to cart');
      if (text) text.textContent = button.dataset.langAvailable || 'Add to cart';
      return;
    }

    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');

    if (variant) {
      /* 终稿主按钮写 OUT OF STOCK；吸底 CTA 保留购买动作名，仅变灰禁用。 */
      var soldLabel = isSticky ? (button.dataset.langAvailable || 'Add to cart') : 'OUT OF STOCK';
      button.setAttribute('aria-label', isSticky ? 'Add to cart, out of stock' : 'Out of stock');
      if (text) text.textContent = soldLabel;
    } else {
      var unavailable = button.dataset.langUnavailable || 'Unavailable';
      button.setAttribute('aria-label', unavailable);
      if (text) text.textContent = unavailable;
    }
  }

  function placeControls(root, productRoot) {
    var status = root._amadaStatus || root.querySelector('[data-amada-restock-status]');

    /* 落位钩子（2026-09-02 新增，为分类页 quick view 抽屉服务）：
       状态行必须显示在价格上方，但两处 DOM 完全不同 ——
       PDP 靠 `.product__meta-content .product__price-block` 定位，
       quick view 抽屉里没有这两个类。给一个可选的 [data-amada-restock-target] 空槽，
       有就插进去、没有就走原来的分支 → **PDP 行为逐字不变**。
       （不复制一份三态逻辑：判据只有 stockState() 一处，改一次两处都对。） */
    var slot = productRoot.querySelector('[data-amada-restock-target]');
    if (status && slot) {
      if (status.parentNode !== slot) slot.appendChild(status);
    } else {
      var price = productRoot.querySelector('.product__meta-content .product__price-block');
      if (status && price && status.parentNode !== price.parentNode) {
        price.parentNode.insertBefore(status, price);
      }
    }

    var notify = root._amadaNotify || root.querySelector('[data-amada-restock-open]');
    var form = productRoot.querySelector('.product-form[data-product-form]');
    var buyRow = form ? form.querySelector('.product-form__quantity-and-buy-buttons-wrapper') : null;
    if (notify && buyRow && notify.previousElementSibling !== buyRow) {
      buyRow.insertAdjacentElement('afterend', notify);
    }
  }

  function updateMessage(root, variant) {
    var message = root.querySelector('[data-amada-restock-message]');
    if (!message) return;
    var productTitle = root.dataset.productTitle || 'Product';
    var productHandle = root.dataset.productHandle || '';
    var variantTitle = variant && variant.title ? variant.title : 'Unknown variant';
    var variantId = variant && variant.id ? variant.id : 'unknown';
    message.value = [
      'Back in stock request for ' + productTitle,
      'Variant: ' + variantTitle + ' (' + variantId + ')',
      'Product handle: ' + productHandle,
      'Page: ' + window.location.href
    ].join('\n');
  }

  function sync(root, variant) {
    /* 作用域：PDP 是 `.product`；quick view 抽屉里没有这个类，用显式的
       [data-amada-restock-scope] 兜底。**顺序不能反** —— PDP 上两者都可能命中，
       先取 .product 才能保证 PDP 一行都不变。 */
    var productRoot = root.closest('.product') || root.closest('[data-amada-restock-scope]');
    if (!productRoot) return;

    placeControls(root, productRoot);
    var state = stockState(variant, root._amadaInventory, root._amadaLowThreshold);
    var isOut = state === 'out';
    /* data-amada-inventory-state 保持 out/available/unavailable 三值不变：
       amada-back-in-stock.css 的售罄 CTA 变灰规则挂在它上面，改语义会一起改坏。
       三态本身挂在状态行自己的 data-stock-state 上。 */
    productRoot.dataset.amadaInventoryState = isOut ? 'out' : (variant ? 'available' : 'unavailable');

    /* 两个控件会被 placeControls() 搬出 root，必须持有初始引用，不能再从 root 查。 */
    var status = root._amadaStatus;
    var notify = root._amadaNotify;
    if (status) {
      status.hidden = !state;
      if (state) {
        status.dataset.stockState = state;
        status.textContent = root._amadaStockText[state] || '';
      } else {
        status.removeAttribute('data-stock-state');
      }
    }
    if (notify) notify.hidden = !isOut;

    var buttons = productRoot.querySelectorAll('[data-add-to-cart]');
    for (var i = 0; i < buttons.length; i++) setButtonState(buttons[i], variant);
    updateMessage(root, variant);
    root._amadaCurrentVariant = variant;
  }

  function focusable(modal) {
    var nodes = modal.querySelectorAll(
      'button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
    );
    var result = [];
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].hidden && nodes[i].getAttribute('aria-hidden') !== 'true') result.push(nodes[i]);
    }
    return result;
  }

  function openModal(root) {
    var modal = root.querySelector('[data-amada-restock-modal]');
    if (!modal || modal.classList.contains(OPEN_CLASS)) return;
    root._amadaLastFocus = document.activeElement;
    root._amadaScrollPosition = {
      x: window.scrollX || window.pageXOffset || 0,
      y: window.scrollY || window.pageYOffset || 0
    };
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add(LOCK_CLASS);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { modal.classList.add(OPEN_CLASS); });
    });
    var email = modal.querySelector('[data-amada-restock-email]');
    if (email) email.focus();
  }

  function closeModal(root) {
    var modal = root.querySelector('[data-amada-restock-modal]');
    if (!modal || modal.hidden) return;
    modal.classList.remove(OPEN_CLASS);
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove(LOCK_CLASS);
    window.setTimeout(function () {
      if (!modal.classList.contains(OPEN_CLASS)) modal.hidden = true;
    }, TRANSITION_MS);
    if (root._amadaLastFocus && document.contains(root._amadaLastFocus)) {
      try {
        root._amadaLastFocus.focus({ preventScroll: true });
      } catch (error) {
        root._amadaLastFocus.focus();
      }
    }
    if (root._amadaScrollPosition) {
      window.scrollTo(root._amadaScrollPosition.x, root._amadaScrollPosition.y);
    }
    root._amadaLastFocus = null;
    root._amadaScrollPosition = null;
  }

  /**
   * 反馈文案的唯一取值口：全部来自 snippet 渲染的 data 属性（后台可配），
   * 取不到才落到本文件顶部的英文兜底常量。
   */
  function copyFor(root) {
    var data = (root && root.dataset) || {};
    return {
      submit: data.restockSubmitLabel || 'sign up',
      submitting: data.restockSubmittingLabel || 'submitting...',
      successTitle: data.restockSuccessTitle || SUCCESS_MESSAGE,
      successBody: data.restockSuccessBody || SUCCESS_BODY,
      error: data.restockError || ERROR_MESSAGE,
      challenge: data.restockChallenge || CHALLENGE_MESSAGE
    };
  }

  /* 提交前打标：记下表单 id / 商品 / 文案 / 时间戳。不存邮箱（PII 不进 sessionStorage）。 */
  function writePending(root, form) {
    var copy = copyFor(root);
    var data = (root && root.dataset) || {};
    try {
      window.sessionStorage.setItem(PENDING_KEY, JSON.stringify({
        v: 1,
        formId: form.id || '',
        productTitle: data.productTitle || '',
        productHandle: data.productHandle || '',
        title: copy.successTitle,
        body: copy.successBody,
        path: window.location.pathname,
        scroll: { x: window.scrollX || window.pageXOffset || 0, y: window.scrollY || window.pageYOffset || 0 },
        ts: Date.now()
      }));
    } catch (error) {
      /* 隐私模式/禁用存储：原生提交照常完成，只是回跳后没有提示，不影响报名本身。 */
    }
  }

  function clearPending() {
    try {
      window.sessionStorage.removeItem(PENDING_KEY);
    } catch (error) {
      /* 同上：读写不可用时静默。 */
    }
  }

  function setSubmitBusy(form, busy) {
    var submit = form.querySelector('[data-amada-restock-submit]');
    var text = form.querySelector('[data-amada-restock-submit-text]');
    var copy = copyFor(form.closest(ROOT_SELECTOR));
    if (submit) submit.disabled = busy;
    if (text) text.textContent = busy ? copy.submitting : copy.submit;
    form.setAttribute('aria-busy', busy ? 'true' : 'false');
    form.dataset.amadaRestockSubmitting = busy ? 'true' : 'false';
  }

  function nativeScrollKey(form) {
    return 'amada-restock-scroll:' + (form.id || 'contact');
  }

  function saveNativeScroll(form) {
    try {
      window.sessionStorage.setItem(nativeScrollKey(form), JSON.stringify({
        x: window.scrollX || window.pageXOffset || 0,
        y: window.scrollY || window.pageYOffset || 0
      }));
    } catch (error) {
      /* Storage may be unavailable in private/restricted contexts; native submit still works. */
    }
  }

  function restoreNativeScroll(form) {
    try {
      var key = nativeScrollKey(form);
      var stored = window.sessionStorage.getItem(key);
      window.sessionStorage.removeItem(key);
      if (!stored) return;
      var position = JSON.parse(stored);
      window.scrollTo(Number(position.x) || 0, Number(position.y) || 0);
    } catch (error) {
      /* A malformed/stale storage value must not prevent server feedback from opening. */
    }
  }

  /* ------------------------------------------------------------------
     提交：交给 Shopify 原生（2026-10-05 第三版，用户拍板「先止血」）
     ------------------------------------------------------------------
     店铺开了 Shopify hCaptcha（storefront-forms-hcaptcha v1.5.3，已读源码）：绑定表单时会用自己的
     函数替换 form.submit，每次提交先 execute 拿一次性 token，再调「绑定时的 submit」原生发出去。
     前两版用脚本接管 submit 改 fetch，和它的流程打架：有时等不到回调（卡在 SUBMITTING），
     兜底强行原生提交又带着无效 token（Shopify 报错页 "Invalid CAPTCHA token"）。
     现在完全不接管：提交与验证码全部由 Shopify 处理，页面刷新一次。回跳后：
       · PDP：表单被重新渲染，snippet 的服务端成功分支在弹窗里给反馈（bind() 末尾自动打开弹窗）；
       · 分类页 quick view：抽屉已随刷新消失，由 layout/theme.liquid 的内联脚本弹成功提示条，
         并恢复到提交前的滚动位置（位置记在待确认记录里）。
     这里只做三件事：
       ① 打待确认记录；② 按钮显示提交中，RESET_MS 后仍停在本页就恢复按钮（不报错、不强行提交）；
       ③ 提交那一刻 hCaptcha 还没绑定好时，验证码脚本只拦截不提交 → 绑定后替用户补交一次。
     ------------------------------------------------------------------ */
  var RESET_MS = 15000;
  var BIND_WAIT_MS = 10000;
  var POLL_MS = 300;

  function submitForm(root, form, event) {
    if (form.dataset.amadaRestockSubmitting === 'true') {
      event.preventDefault();
      return;
    }
    updateMessage(root, root._amadaCurrentVariant);
    var boundAtSubmit = !!form.dataset.hcaptchaBound;
    writePending(root, form);
    saveNativeScroll(form);
    setSubmitBusy(form, true);

    if (form._amadaRestockReset) window.clearTimeout(form._amadaRestockReset);
    form._amadaRestockReset = window.setTimeout(function () {
      form._amadaRestockReset = null;
      setSubmitBusy(form, false);
    }, RESET_MS);

    /* 本轮事件派发完再看：被验证码脚本拦下、且提交时还没绑定 → 等绑定后补交一次 */
    window.setTimeout(function () {
      if (!event.defaultPrevented || boundAtSubmit || typeof form.requestSubmit !== 'function') return;
      var waited = 0;
      var timer = window.setInterval(function () {
        waited += POLL_MS;
        if (form.dataset.hcaptchaBound) {
          window.clearInterval(timer);
          form.requestSubmit();
        } else if (waited >= BIND_WAIT_MS) {
          window.clearInterval(timer);
        }
      }, POLL_MS);
    }, 0);
  }

  function bind(root) {
    if (root.dataset.amadaRestockReady === 'true') return;
    root.dataset.amadaRestockReady = 'true';
    root._amadaStatus = root.querySelector('[data-amada-restock-status]');
    root._amadaNotify = root.querySelector('[data-amada-restock-open]');
    root._amadaInventory = parseInventory(root);
    var threshold = parseInt(root.dataset.stockLowThreshold, 10);
    root._amadaLowThreshold = isNaN(threshold) ? DEFAULT_LOW_THRESHOLD : threshold;
    root._amadaStockText = {
      in: root.dataset.stockTextIn || 'IN STOCK',
      low: root.dataset.stockTextLow || 'LOW STOCK',
      out: root.dataset.stockTextOut || 'OUT OF STOCK'
    };
    var variants = parseVariants(root);
    var initial = findVariant(variants, root.dataset.initialVariantId);
    sync(root, initial);

    if (root._amadaNotify) {
      root._amadaNotify.addEventListener('click', function (event) {
        event.preventDefault();
        openModal(root);
      });
    }

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-amada-restock-close]')) {
        event.preventDefault();
        closeModal(root);
      }
    });

    root.addEventListener('keydown', function (event) {
      var modal = root.querySelector('[data-amada-restock-modal]');
      if (!modal || modal.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal(root);
        return;
      }
      if (event.key !== 'Tab') return;
      var items = focusable(modal);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    var form = root.querySelector('[data-amada-restock-form]');
    if (form) {
      form.addEventListener('submit', function (event) {
        submitForm(root, form, event);
      });
    }

    if (root.querySelector('[data-amada-restock-server-state]')) {
      window.setTimeout(function () {
        restoreNativeScroll(form);
        openModal(root);
      }, 50);
    }
  }

  function initAll() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) bind(roots[i]);
  }

  function rootsForVariantEvent(event) {
    var detail = event && event.detail ? event.detail : {};
    if (detail.amadaScope === 'qv') {
      var quickView = document.querySelector(QUICK_VIEW_DRAWER_SELECTOR);
      return quickView ? quickView.querySelectorAll(ROOT_SELECTOR) : [];
    }

    var all = document.querySelectorAll(ROOT_SELECTOR);
    var pdpRoots = [];
    for (var i = 0; i < all.length; i++) {
      if (!all[i].closest(QUICK_VIEW_DRAWER_SELECTOR)) pdpRoots.push(all[i]);
    }
    return pdpRoots;
  }

  /* 对外暴露：AJAX 插进来的 DOM（quick view 抽屉）里 DOMContentLoaded / shopify:section:load
     都早过去了，必须由调用方填完内容后主动 init()。 */
  window.AmadaRestock = { init: initAll, bind: bind, sync: sync };

  document.addEventListener('product:variant-change', function (event) {
    var roots = rootsForVariantEvent(event);
    var variant = event && event.detail ? event.detail.variant : null;
    for (var i = 0; i < roots.length; i++) sync(roots[i], variant);
  });
  document.addEventListener('shopify:section:load', initAll);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
